<template>
  <svg width="534" height="147" viewBox="0 0 534 147" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#logo-mark-type-clip0_2199_14953)">
      <mask
        id="logo-mark-type-mask0_2199_14953"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="51"
        y="52"
        width="96"
        height="95"
      >
        <path d="M51.1957 52.1954L51.1957 147H146V52.1954H51.1957Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#logo-mark-type-mask0_2199_14953)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M94.8038 146.999C94.8038 118.726 117.724 95.805 145.998 95.805C145.998 95.805 145.999 95.805 145.999 95.805V52.1949C133.549 52.1949 121.221 54.6471 109.719 59.4114C98.2169 64.1757 87.7658 71.159 78.9624 79.9624C70.159 88.7658 63.1757 99.2172 58.4114 110.719C53.6471 122.222 51.1948 134.549 51.1948 146.999H94.8038Z"
          fill="#D3DAE9"
        />
      </g>
      <mask
        id="logo-mark-type-mask1_2199_14953"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="52"
        width="95"
        height="95"
      >
        <path d="M94.8046 52.1945H0V146.999H94.8046V52.1945Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#logo-mark-type-mask1_2199_14953)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.00012207 95.8051L0.000123977 52.195C12.45 52.195 24.778 54.6472 36.2802 59.4115C47.7825 64.1758 58.2336 71.1592 67.037 79.9625C75.8404 88.7659 82.8237 99.2173 87.588 110.719C92.3525 122.222 94.8046 134.55 94.8046 147H51.1933C51.1933 118.726 28.2734 95.8058 0.00012207 95.8051Z"
          fill="#016299"
        />
      </g>
      <mask
        id="logo-mark-type-mask2_2199_14953"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="51"
        y="1"
        width="96"
        height="95"
      >
        <path d="M146 1H51.1957V95.8046H146V1Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#logo-mark-type-mask2_2199_14953)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M109.72 88.5891C121.222 93.3534 133.55 95.8057 146 95.8057V52.1941C146 52.1941 145.999 52.1941 145.999 52.1941C117.725 52.1941 94.8053 29.2743 94.8044 1.00114L51.1957 1.00113C51.1957 13.451 53.648 25.7792 58.4123 37.2813C63.1765 48.7834 70.1599 59.2347 78.9632 68.0381C87.7666 76.8415 98.2177 83.8248 109.72 88.5891Z"
          fill="#1292DA"
        />
      </g>
    </g>
    <path
      d="M230.48 97.1698L220.512 87.0898C216.368 91.0098 212.448 93.4738 206.736 93.4738C197.44 93.4738 191.504 86.0818 191.504 76.8978V76.6738C191.504 67.8258 197.552 60.3218 206.064 60.3218C212.112 60.3218 215.92 62.8978 219.728 66.9298L230.144 55.7298C224.544 49.4578 217.488 45.6498 206.176 45.6498C187.808 45.6498 174.704 59.7618 174.704 76.8978V77.1218C174.704 94.2578 187.92 108.146 205.952 108.146C217.936 108.146 224.656 103.554 230.48 97.1698ZM275.536 63.4578V45.6498C265.456 45.2018 259.856 50.5778 256.384 58.8658V46.7698H239.36V106.802H256.384V84.6258C256.384 70.2898 263.328 63.4578 274.64 63.4578H275.536ZM338.292 78.4658V78.2418C338.292 61.2178 329.108 45.6498 309.06 45.6498C291.588 45.6498 279.38 59.7618 279.38 76.8978V77.1218C279.38 95.4898 292.708 108.146 310.74 108.146C321.604 108.146 329.668 103.89 335.268 96.9458L325.524 88.3218C320.82 92.6898 316.676 94.4818 310.964 94.4818C303.348 94.4818 297.972 90.4498 296.292 82.7218H338.068C338.18 81.1538 338.292 80.1458 338.292 78.4658ZM321.716 72.0818H296.068C297.412 64.3538 302.004 59.3138 309.06 59.3138C316.228 59.3138 320.708 64.4658 321.716 72.0818ZM409.108 106.802V25.0418H392.084V54.6098C388.052 49.7938 382.452 45.6498 373.38 45.6498C359.156 45.6498 346.052 56.6258 346.052 76.6738V76.8978C346.052 96.9458 359.38 107.922 373.38 107.922C382.228 107.922 387.94 103.778 392.084 98.1778V106.802H409.108ZM392.308 76.8978C392.308 86.8658 385.7 93.4738 377.748 93.4738C369.796 93.4738 363.076 86.8658 363.076 76.8978V76.6738C363.076 66.5938 369.796 60.0978 377.748 60.0978C385.7 60.0978 392.308 66.7058 392.308 76.6738V76.8978ZM466.094 88.5458V88.3218C466.094 77.3458 456.35 73.3138 447.95 70.5138C441.454 68.2738 435.742 66.7058 435.742 63.3458V63.1218C435.742 60.7698 437.87 58.9778 442.014 58.9778C446.382 58.9778 452.318 61.1058 458.254 64.5778L464.75 52.8178C458.254 48.4498 449.966 45.8738 442.35 45.8738C430.254 45.8738 420.398 52.7058 420.398 64.9138V65.1378C420.398 76.7858 429.918 80.7058 438.318 83.1698C444.926 85.1858 450.75 86.4178 450.75 90.1138V90.3378C450.75 93.0258 448.51 94.8178 443.582 94.8178C437.982 94.8178 431.15 92.3538 424.654 87.6498L417.374 98.8498C425.326 105.122 434.734 107.922 443.134 107.922C456.126 107.922 466.094 101.874 466.094 88.5458ZM531.536 46.7698H513.84L500.736 87.6498L487.072 46.7698H469.04L492.56 107.026C491.104 110.05 489.536 110.946 486.624 110.946C484.384 110.946 481.584 109.938 479.344 108.594L473.632 120.914C478 123.49 482.592 125.058 488.752 125.058C498.944 125.058 503.872 120.466 508.464 108.258L531.536 46.7698Z"
      fill="#0F2C37"
    />
    <defs>
      <clipPath id="logo-mark-type-clip0_2199_14953">
        <rect width="146" height="146" fill="white" transform="translate(0 1)" />
      </clipPath>
    </defs>
  </svg>
</template>
